import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/build/')({
  preload: false,
  beforeLoad: () => {
    throw redirect({ to: '/tech-ops/build/repo' });
  },
});
